$(function () {
    $('#ReserveConfirmFinal .backBtn').click(() => {
        $('#reserve_form input[type="submit"]').prop('disabled', true)
        $('#reserve_form .backBtn').addClass('disabled')
        let action = $('#reserve_form').attr('action');
        action = action.replace("reserves/reserve", "reserves/confirm_payment");
        $('#reserve_form').attr('action', action);
        document.getElementById("reserve_form").submit();
    })
    $('#ReserveConfirmFinal input[name="agreement"]').click(() => {
        monitoringAgreement();
    })
    monitoringAgreement();
});

// 同意ボタンのチェック有無で送信ボタンを有効にする
function monitoringAgreement () {
    if ($('#ReserveConfirmFinal input[name="agreement"]').is(':checked')) {
        $('#ReserveConfirmFinal input[type="submit"]').prop('disabled', false);
    } else {
        $('#ReserveConfirmFinal input[type="submit"]').prop('disabled', true);
    }
}